import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutResponsibleHist extends Layout {
    sourceResponsibleHist: DataSource;
    tableResponsibleHist: Table;
}
